<template>
  <div class="page">
    <div class="app-container">
      <BaseTable
        ref="baseTable"
        url="/admin/areaDiscount/index"
        :tableData.sync="tableData"
        :columns="columns"
        :searchParams="searchData"
      >
        <template #custom="{ scope }">
          {{ scope.row.title }}
        </template>
        <template #handle="{ row }">
          <el-button type="text" size="mini" @click="edit(row)">编辑</el-button>
        </template>
      </BaseTable>

      <el-drawer
        :title="'编辑折扣政策'"
        :visible.sync="isShowDrawer"
        direction="rtl"
      >
        <div style="padding: 40px" v-loading="loading">
          <el-form ref="form" :model="formData" :rules="rules" labelWidth="120px" size="medium">
            <el-form-item label="折扣比例" prop="discount" >
              <el-input v-model="formData.discount" required></el-input>
            </el-form-item>
            
            <el-form-item>
              <el-button type="primary" @click="onSubmit">保存</el-button>
            </el-form-item>
          </el-form>
        </div>
      </el-drawer>
    </div>
  </div>
</template>

<script>
import { columns } from "./columns";
import { rules } from './rules'

export default {
  name: "discount",
  comments: {},
  data() {
    return {
      tableData: [],
      isShowDrawer: false,
      formData: {},
      searchData: {},
      loading: false,
    };
  },
  computed: {
    columns,
    rules
  },
  created() {
    this.$store.dispatch('app/getCarType')
	this.$store.dispatch('app/getUseType')
  },
  methods: {

    edit(row) {
      this.formData = row;
      console.log('xxxxxxxxxxxxxxxxxxxxxx',row);
      this.isShowDrawer = true;
    },

    onSubmit() {
      this.$refs.form.validate((v) => {
        if(v) {
          this.$api.post("/admin/areaDiscount/save", this.formData, "更新").then(() => {
            this.isShowDrawer = false;
            this.$refs.baseTable.searchData();
          });
        }
      })
      
    },

  },
};
</script>
